import { Observable } from 'rxjs';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CommunicationConfigService } from '../communication-config/communication-config.service';
import { CsrfService } from '../csrf/csrf.service';

@Injectable({
  providedIn: 'root'
})
export class HttpInterceptorService implements HttpInterceptor {
  constructor(private back: CommunicationConfigService, private csrfService: CsrfService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // On initalise l'objet des headers
    let finalRequest = req.clone({
      params: req.params.append('schema_name', `${this.back.getIdentifier()}`),
      //TODO JRM  WE should add to  headers: req.headers.append('schema', `argalis_${this.back.getIdentifier()}`)
      // and req.headers.set('Access-Control-Allow-Origin', '*')
      headers: req.headers.set('Access-Control-Allow-Origin', '*')
    });

    // important (pour les cookies et d'autres) on ajoute le credential
    finalRequest = finalRequest.clone({
      withCredentials: true
    });

    // protection CSRF
    if (req.method === 'POST' || req.method === 'PUT' || req.method === 'DELETE' || req.method === 'GET') {
      // Si route protéger par csrf guard, le token est obligatoire
      const token = this.csrfService.getToken();
      if (token) {
        finalRequest = finalRequest.clone({
          headers: finalRequest.headers.set('X-CSRFToken', `${token}`)
        });
      }
    }

    return next.handle(finalRequest);
  }
}
